import { observer } from "mobx-react-lite"

import { DisplayTokenTableValues } from "@/components/display-token-values"
import { dollarsPrettified, formatPercentage } from "@/domains/library"
import { ILiquidityPool } from "@/domains/pools"

export const StakedColumn = observer(({ pool, isCompact }: { pool: ILiquidityPool; isCompact: boolean }) => {
  if (!pool) {
    return <p className="text-t100">{dollarsPrettified(0)}</p>
  }

  if (isCompact) {
    return <div className="text-t100">{dollarsPrettified(pool.gaugeValueUSD)}</div>
  }
  return (
    <>
      <>
        <span className="text-t100">{dollarsPrettified(pool.gaugeValueUSD)}</span>{" "}
        <span className="text-t300">({formatPercentage(pool.gaugeTotalSupplyPercentage, 2)})</span>
      </>
      <DisplayTokenTableValues tokens={pool.tokens} values={pool.gaugeReserves} />
    </>
  )
})
